/* src/app/components/terminals/terminal/terminal.component.css */
.controls {
  margin-top: 20px;
  display: flex;
}
.BetriebsstaetteMatSelect mat-select {
  height: 0 !important;
}
/*# sourceMappingURL=terminal.component-I6BM6HPR.css.map */
